import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RECEIVE_V_LIST2, SET_MASK } from '../../../store/fuerzaventas/gestionpreciosespeciales/types';

import './table.css';

import makeStyles from '@material-ui/core/styles/makeStyles';
import * as XLSX from 'xlsx';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import { closeMessageBox, openMessageBox } from '../../../store/main/actions';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '120%',
    },
    progress: {
        height: '2rem',
        width: '2rem',
        '@media (min-width: 701px)': {
            height: '2.5rem',
            width: '2.5rem',
        },
    },
    content: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        top: 'calc(50% - 20px)',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    tableWrap: {
        flex: '1 1 auto',
    },
}));

const GestionPreciosEspecialesImportar = () => {
    const classes = useStyles();
    const loading = useSelector((state) => state.gestionpreciosespeciales.loading);
    const store = useSelector((state) => state.gestionpreciosespeciales.stored);
    const col = useSelector((state) => state.gestionpreciosespeciales.store.col);

    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [, setFile] = useState([]);
    const [head, setHead] = useState([]);

    useEffect(() => {
        setData(store.data);
        if (store.data.length > 0) {
        }
        return () => {
            setData([]);
        };
    }, [store.data]);

    function readExcel(archivo) {
        if (archivo === '' || archivo === undefined) {
            setFile('');
            setHead([]);
            return;
        }

        // Limpiar estados antes de procesar el nuevo archivo
        setHead([]);
        setFile([]);
        setData([]);
        dispatch({ type: RECEIVE_V_LIST2, columns: [], payload: [] });

        const extensionesPermitidas = /(.xls|.xlsx)$/i;
        if (!extensionesPermitidas.test(archivo.name)) {
            dispatch(
                openMessageBox({
                    button: 'ok',
                    icon: 'warning',
                    message: 'Use el formato correcto para la carga (.xls o .xlsx)',
                    callback: () => dispatch(closeMessageBox()),
                }),
            );
            return;
        }

        const lectorArchivo = new FileReader();
        lectorArchivo.readAsArrayBuffer(archivo);

        lectorArchivo.onload = (evento) => {
            const bufferArray = evento.target.result;
            const libroExcel = XLSX.read(bufferArray, { type: 'buffer' });
            const nombreHoja = libroExcel.SheetNames[0];
            const hoja = libroExcel.Sheets[nombreHoja];

            // Usar defval para forzar que incluya todas las columnas aunque estén vacías
            const datosExcel = XLSX.utils.sheet_to_json(hoja, { defval: '' });

            // Validación 1: Archivo vacío
            if (datosExcel.length === 0) {
                dispatch(
                    openMessageBox({
                        button: 'ok',
                        icon: 'warning',
                        message: 'El archivo no puede estar vacío.',
                        callback: () => dispatch(closeMessageBox()),
                    }),
                );
                dispatch({ type: SET_MASK, loading: false });
                return;
            }

            // Validación 2: Formato de columnas (cabeceras)
            const todasLasCabecerasExcel = Object.keys(datosExcel[0]);
            const columnasEsperadas = col; // ['Nit_Ruc', 'CodigoCliente', ...]

            // Tomar solo las primeras N columnas (ignorar columnas extras a la derecha)
            const cabecerasExcel = todasLasCabecerasExcel.slice(0, columnasEsperadas.length);

            // Filtrar los datos del Excel para usar solo las columnas esperadas
            const datosExcelFiltrados = datosExcel.map((fila) => {
                const filaFiltrada = {};
                cabecerasExcel.forEach((cabecera) => {
                    filaFiltrada[cabecera] = fila[cabecera];
                });
                return filaFiltrada;
            });

            // Validar cantidad de columnas (después de tomar solo las primeras N)
            if (cabecerasExcel.length < columnasEsperadas.length) {
                dispatch(
                    openMessageBox({
                        button: 'ok',
                        icon: 'warning',
                        message: `Formato de Columnas no Válido. Se esperaban ${columnasEsperadas.length} columnas pero se encontraron solo ${cabecerasExcel.length}.`,
                        callback: () => dispatch(closeMessageBox()),
                    }),
                );
                setHead([]);
                dispatch({ type: SET_MASK, loading: false });
                return;
            }

            // Validar nombres de columnas y orden
            const erroresColumnas = [];
            cabecerasExcel.forEach((cabeceraExcel, index) => {
                const columnaEsperada = columnasEsperadas[index];
                if (cabeceraExcel !== columnaEsperada) {
                    erroresColumnas.push(`Columna ${index + 1}: Se esperaba "${columnaEsperada}" pero se recibió "${cabeceraExcel}"`);
                }
            });

            if (erroresColumnas.length > 0) {
                const mensajeError = `Formato de Columnas no Válido:\n\n${erroresColumnas.join('\n')}`;
                dispatch(
                    openMessageBox({
                        button: 'ok',
                        icon: 'warning',
                        message: mensajeError,
                        callback: () => dispatch(closeMessageBox()),
                    }),
                );
                setHead([]);
                dispatch({ type: SET_MASK, loading: false });
                return;
            }

            // Validación 3: Campos obligatorios en todas las filas
            const erroresEncontrados = [];
            const camposOpcionales = ['Observacion', 'CodigoSucursal']; // Solo este campo es opcional

            datosExcel.forEach((fila, indiceFila) => {
                const numeroFilaExcel = indiceFila + 2; // +2 porque Excel empieza en 1 y hay cabecera

                cabecerasExcel.forEach((nombreCampo) => {
                    // Si el campo es opcional, no validar
                    if (camposOpcionales.includes(nombreCampo)) {
                        return;
                    }

                    const valorCampo = fila[nombreCampo];

                    // Validar si el campo está vacío, es null, undefined o solo espacios
                    if (valorCampo === undefined || valorCampo === null || valorCampo === '' || (typeof valorCampo === 'string' && valorCampo.trim() === '')) {
                        erroresEncontrados.push(`El campo "${nombreCampo}" es obligatorio en la fila ${numeroFilaExcel} de datos (fila ${numeroFilaExcel + 1} del Excel incluyendo cabecera)`);
                    }
                });
            });

            // Si hay errores, mostrar todos
            if (erroresEncontrados.length > 0) {
                const mensajeError =
                    erroresEncontrados.length === 1
                        ? erroresEncontrados[0]
                        : `Se encontraron ${erroresEncontrados.length} errores:\n\n${erroresEncontrados.slice(0, 10).join('\n')}${erroresEncontrados.length > 10 ? `\n\n... y ${erroresEncontrados.length - 10} errores más.` : ''}`;

                dispatch(
                    openMessageBox({
                        button: 'ok',
                        icon: 'warning',
                        message: mensajeError,
                        callback: () => dispatch(closeMessageBox()),
                    }),
                );
                setHead([]);
                dispatch({ type: SET_MASK, loading: false });
                return;
            }

            // Si todas las validaciones pasan, procesar el archivo
            setHead(cabecerasExcel);
            setFile(datosExcel);
            dispatch({
                type: RECEIVE_V_LIST2,
                columns: cabecerasExcel,
                payload: datosExcel,
            });
        };

        lectorArchivo.onerror = (error) => {
            dispatch(
                openMessageBox({
                    button: 'ok',
                    icon: 'error',
                    message: 'Error al leer el archivo. Intente nuevamente.',
                    callback: () => dispatch(closeMessageBox()),
                }),
            );
            dispatch({ type: SET_MASK, loading: false });
        };
    }

    function HeadTable() {
        if (head.length > 0) {
            return head.map((key, index) => {
                return (
                    <th key={index} style={{ backgroundColor: 'lightsteelblue', height: '100%', textAlign: 'center', width: '1000px', wordwrap: 'break-word' }}>
                        {key}{' '}
                    </th>
                );
            });
        } else {
            return null;
        }
    }

    return (
        <>
            <div style={{ backgroundColor: 'transparent', width: '100%' }}>
                <span style={{ fontSize: '12px', marginTop: '25px', marginLeft: '10px' }}> Importar Precios Especiales</span>
                <div style={{ display: loading ? 'block' : 'none' }}>
                    <div className={classes.content}></div>
                </div>

                <Grid item xs style={{ marginTop: '15px' }}>
                    <FormControl className={classes.filterClear}>
                        <label style={{ marginLeft: '20px', background: '#e62e2d', color: 'white', borderRadius: '5px', width: '140px', height: '30px', display: false, cursor: 'pointer' }} disable="true">
                            {' '}
                            <i className={'fa fa-upload'} style={{ marginTop: '8px', width: '20px', height: '20px', marginLeft: '15px', color: 'white', marginRight: '5px' }} />
                            Subir Archivo
                            <input
                                type="file"
                                style={{ opacity: 0 }}
                                onChange={(e) => {
                                    const archivo = e.target.files[0];
                                    readExcel(archivo);
                                }}
                            />
                        </label>
                    </FormControl>
                </Grid>
                <span style={{ fontSize: '10px', marginTop: '20px', marginLeft: '10px' }}> </span>
                <table>
                    <thead>
                        <tr>
                            <th>-</th>
                            {data.length > 0 && <HeadTable />}
                        </tr>
                    </thead>
                    <tbody>
                        {store.data.length > 0 &&
                            data.map((rowData, id) => (
                                <tr key={id}>
                                    <th>{id + 1}</th>
                                    {store.data.length > 0 &&
                                        head.map((key, index) => {
                                            return (
                                                <th
                                                    key={index}
                                                    style={{
                                                        width: index === 155 ? '30000000px' : '',
                                                        background: index === 154 ? 'lightsteelblue' : 'white' /*checkErrorField(rowData[key]) */,
                                                        height: '100%',
                                                        wordwrap: 'break-word',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    {rowData[key]}
                                                </th>
                                            );
                                        })}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default GestionPreciosEspecialesImportar;
